import { useTranslation } from 'react-i18next';
import { GeofenceFormModel } from '@casops/store/apis/geofencesApi';
import useInputOptions from './useInputOptions';
import useOutputOptions from './useOutputOptions';
import CasFormMultiselect from '@cas/components/inputs/cas-form-multiselect/CasFormMultiselect';
import { UseGeofenceFormTabsProps } from '../form/useGeofenceFormTabs';

type FormModel = GeofenceFormModel;

export function InputOutputControls({ control, isReadonly }: UseGeofenceFormTabsProps<FormModel>) {
  const { t } = useTranslation();

  return (
    <>
      <CasFormMultiselect<FormModel, number>
        control={control}
        name="rules.createEventOnInputs"
        label={t('Fields.EventIfInputs')}
        useItemsHook={useInputOptions}
        displaySelectionLimit={3}
        isReadonly={isReadonly}
      />
      <CasFormMultiselect<FormModel, number>
        control={control}
        name="rules.driveOutputs"
        label={t('Fields.DriveOutputs')}
        useItemsHook={useOutputOptions}
        displaySelectionLimit={3}
        isReadonly={isReadonly}
      />
    </>
  );
}

export default InputOutputControls;
